import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import CatalogoCompetenze from "./sections/CatalogoCompetenze";
import CybersecurityBusinessContinuity from "./sections/CybersecurityBusinessContinuity";
import RichiediUnAudit from "./sections/RichiediUnAudit";
import PièDiPagina from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <CatalogoCompetenze />
      <CybersecurityBusinessContinuity />
      <RichiediUnAudit />
      <PièDiPagina />
    </div>;
}